import React, { useState, useEffect } from "react";
import { 
	Layout, Menu, Avatar, Space, Drawer, Button,
	message 
} from "antd";
import {
	DownOutlined,
	UserOutlined,
	PoweroffOutlined,
	MenuOutlined,
} from "@ant-design/icons";
import "../../../index.css";
import constants from "../../../constants/constants";
import { useHistory,useLocation } from "react-router";
import { fetchAdminApi } from "../../../services/api";
import { useAuth } from "../../../globalFunctions/AuthContext";
// import { fetchApi } from "./services/api";
const { Header } = Layout;
const { SubMenu } = Menu;
const AdminHeaders = () => {
	const { user, clearUserData } = useAuth();
	let location = useLocation();
	// Mobile Menu
	const [mobileMenu, setMobileMenu] = useState(false);
	const [userId, setUserId] = useState(null);
	const [name, setName] = useState(null);
	const history = useHistory();
	const [current, setCurrent] = useState(
		location.pathname === "/admin-login"
			? "/admin-dashboard"
			: location.pathname,
	);
	useEffect(() => {
		let userId = user?.userId;
		if (userId) {
			let name = {};
			name.firstName = user?.firstName;
			name.lastName = user?.lastName;
			setName(name);
			setUserId(userId);
		}
	}, []);
	useEffect(() => {
		if (location) {
			if( current !== location.pathname ) {
				setCurrent(location.pathname);
			}
		}
	}, [location, current]);
	const showMobileMenu = () => {
		setMobileMenu(true);
	};
	const closeMobileMenu = () => {
		setMobileMenu(false);
	};
	const handleLogout = () => {
		let userId = user?.userId;
		let payload = null;
		payload = { is_logged_in: 0, };
		fetchAdminApi(`/logout/${userId}`, "post", payload).then((res) => {
			if (res && res.code && res.code === 200) {
				sessionStorage.removeItem("idFromMyProfile");
				window.location.href = constants.BaseUrl + "/admin-login";
				clearUserData();
			} else {
				message.error(res.message);
			}
		});
	};
	function handleClick(e) {
		setCurrent(e.key);
	}
	return (
		<Header className="header-light slp-header pl-4 pr-3">
			{userId ? (
				<div>
					<div className="logo">
						<Space>
							<div className="mobile-menu-div">
								<Button
									type="primary"
									shape="circle"
									icon={<MenuOutlined/>}
									onClick={showMobileMenu}
								/>
							</div>
							<h2 className="mb-0" onClick={() => {
								window.location.href = constants.BaseUrl + "/admin-dashboard";
							}}>SLP Praxis Review</h2>
						</Space>
					</div>
					<div className="pc-navbar">
						<Menu mode="horizontal" onClick={handleClick} defaultSelectedKeys={["/admin-dashboard"]} selectedKeys={[current]}>
							<Menu.Item
								key="/admin-dashboard"
								// onClick={() => {
								// 	window.location.href = constants.BaseUrl + "/admin-dashboard";
								// }}
								onClick={()=>{
									history.push("/admin-dashboard");
								}}
							>
								Home
							</Menu.Item>
							<Menu.Item key="Analysis"	onClick={()=>{history.push("/analysis-menu");}}>
								Analysis
							</Menu.Item>
							<Menu.Item key="Masters"	onClick={()=>{history.push("/masters-menu");}}>
								Masters
							</Menu.Item>
							<SubMenu
								key="Profile"
								title={
									<Space>
										<Avatar className="avatar">
											{" "}
											{name && name.firstName && name.firstName.charAt(0)}
										</Avatar>
										<span className="navy">
											{" "}
											{(name && name.firstName) +
												" " +
												(name && name.lastName && name.lastName.charAt(0))}
										</span>
										<DownOutlined/>
									</Space>
								}
							>
								<Menu.Item
									key="psettings"
									icon={<UserOutlined/>}
									onClick={() => {
										history.push("my-profile");
									}}
								>
									My Profile
								</Menu.Item>
								<Menu.Item
									key="logout"
									icon={<PoweroffOutlined/>}
									onClick={handleLogout}
								>
									Logout
								</Menu.Item>
							</SubMenu>
						</Menu>
					</div>
					{/* Mobile Menu Start */}
					<div className="mobile-menu-div">
						<Drawer
							title="PRAXIS - SLP Review"
							placement="left"
							className="mobile-menu"
							onClose={closeMobileMenu}
							visible={mobileMenu}
						>
							<Menu mode="inline"  onClick={handleClick} defaultSelectedKeys={["/admin-dashboard"]} selectedKeys={[current]}>
								<Menu.Item
									key="/admin-dashboard"
									// onClick={() => {
									// 	window.location.href = constants.BaseUrl + "/admin-dashboard";
									// }}
									onClick={()=>{
										history.push("/admin-dashboard");
									}}
								>
								Home
								</Menu.Item>
								<Menu.Item key="Analysis"	onClick={()=>{history.push("/analysis-menu");}}>
									Analysis
								</Menu.Item>
								<Menu.Item key="Masters"	onClick={()=>{history.push("/masters-menu");}}>
									Masters
								</Menu.Item>
								<SubMenu
									key="Profile"
									title={
										<Space>
											<Avatar className="avatar">
												{name && name.firstName}
											</Avatar>
											<span className="navy">
												{(name && name.firstName) +
													" " +
													(name && name.lastName)}
											</span>
										</Space>
									}
								>
									<Menu.Item
										key="psettings"
										icon={<UserOutlined/>}
										onClick={() => {
											history.push("my-profile");
										}}
									>
										My Profile
									</Menu.Item>
									<Menu.Item key="logout" icon={<PoweroffOutlined/>} 
										onClick={handleLogout}
									>
										Logout
									</Menu.Item>
								</SubMenu>
							</Menu>
						</Drawer>
					</div>
					{/* Mobile Menu End */}
				</div>
			) : (
				<div>
					{/* Login header start */}
					<div className="logo bookname mt-3">
						<Space>
							<div className="mobile-menu-div">
								<Button
									type="primary"
									shape="circle"
									icon={<MenuOutlined/>}
									onClick={showMobileMenu}
									className="menu-btn"
								/>
							</div>
							<h3 className="mb-0">
								An Advanced Review of Speech-Language Pathology, 6th Edition:
								Practice Examinations
							</h3>
						</Space>
					</div>
					<div className="pc-navbar">
						{/* <Menu mode="horizontal">
							<Menu.Item key="author1" onClick={()=>{window.open('https://arpslp.opspldev.in/celeste-roseberry-mckibbin/', '_blank');}}>
								Celeste Roseberry-McKibbin, Ph.D.
							</Menu.Item>
							<Menu.Item key="author2" onClick={()=>{window.open('https://arpslp.opspldev.in/m-n-giri-hegde/', '_blank');}}>M. N. Hegde, Ph.D.</Menu.Item>
							<Menu.Item key="author3" onClick={()=>{window.open('https://arpslp.opspldev.in/dr-glen-tellis/', '_blank');}}>Glen M. Tellis, Ph.D.</Menu.Item>
						</Menu> */}
					</div>
					{/* Mobile Menu Start */}
					<div className="mobile-menu-div">
						<Drawer
							title="PRAXIS - SLP Review"
							placement="left"
							className="mobile-menu"
							onClose={closeMobileMenu}
							visible={mobileMenu}
						>
							<Menu mode="inline">
								<Menu.Item key="author1">Glen M. Tellis, PhD</Menu.Item>
								<Menu.Item key="author2">M. N. Hegde, PhD</Menu.Item>
								<Menu.Item key="author3">
									Celeste Roseberry-McKibbin, PhD
								</Menu.Item>
							</Menu>
						</Drawer>
					</div>
					{/* Mobile Menu End */}
					{/* Login header end */}
				</div>
			)}
		</Header>
	);
};
export default AdminHeaders;
